let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1ndPi")).then(() => parcelRequire('7IFni'));